import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-page" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "footer-hints" }
const _hoisted_4 = { class: "footer-hint-left" }
const _hoisted_5 = { class: "footer-hint-right" }
const _hoisted_6 = { class: "address" }
const _hoisted_7 = { class: "code-title" }
const _hoisted_8 = { class: "code-title" }
const _hoisted_9 = { class: "code-title" }
const _hoisted_10 = { class: "footer-bottom" }

import code1 from '@/assets/image/other/1.webp';
import code2 from '@/assets/image/other/2.webp';
import code3 from '@/assets/image/other/3.webp';
import logo from '@/assets/image/other/logo.webp';

export default /*@__PURE__*/_defineComponent({
  __name: 'commonFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      class: "footer",
      gutter: 50
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          class: "footer-col",
          span: 10
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_image, {
              class: "logo",
              src: _unref(logo)
            }, null, 8, ["src"]),
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('footer.online_service')), 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('footer.service_hotline')), 1),
                _cache[0] || (_cache[0] = _createElementVNode("p", null, "400-181-0855", -1)),
                _cache[1] || (_cache[1] = _createElementVNode("p", null, "400-895-6696", -1))
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('footer.online_time')), 1),
                _cache[2] || (_cache[2] = _createElementVNode("p", null, "09:00-12:00 13:00-17:00", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('footer.opening_days')), 1)
              ])
            ]),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('footer.address')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 14 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 50 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: _unref(code1) }, null, 8, ["src"]),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('footer.vitalqi_official_account')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: _unref(code2) }, null, 8, ["src"]),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('footer.warm_life_official_account')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: _unref(code3) }, null, 8, ["src"]),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('footer.nuanya_official_account')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('footer.copyright')), 1)
    ])
  ]))
}
}

})